import { Container, Row, Col } from 'react-bootstrap';
import './Footer.css'
import SocialItems from './SocialItems';

export default function Footer() {
    return <Container className='mt-5'>
        <Row>
            <Col className="text-center" md={{span: 3, offset: 0}} xs={{span: 6, offset: 3}}>
                <a rel="noopener" target="_blank" href="https://www.alepe.pe.gov.br"><img src='/img/alepe-logo.png' className='logo-alepe-rodape'/></a>
            </Col>
            <Col md={2}>
                <Row>
                    <Col sm={9} xs={10}>
                        <p className="info info-title">FONE</p>
                        <p className="info info-content">(81) 3138-2211</p>
                        <p className="info info-title">Email</p>
                        <p className="info info-content">alepe@alepe.pe.gov.br</p>
                    </Col>
                </Row>
            </Col>
            <Col md={{span: 3, offset: 0}} xs={{span: 6, offset: 3}}>
                    <p className="info info-title">SERVIÇO DE INFORMAÇÃO AO CIDADÃO E OUVIDORIA</p>
                    <p className="info info-content">(81) 3183-2002</p>
                    <p className="info info-content">ouvidoria@alepe.pe.gov.br</p>
            </Col>
            <Col md={2} className="text-center">
                <a rel="noopener" target="_blank" href="/img/certificado_prata.pdf"><img src='/img/prata.png' style={{maxWidth: '80%'}} className='logo-alepe-rodape'/></a>
                <a rel="noopener" target="_blank" href="https://radardatransparencia.atricon.org.br/"><img src='/img/radar.png' style={{maxWidth: '60%', marginTop: '20px'}} className='logo-alepe-rodape'/></a>
            </Col>
            <Col md={2}>
                <Row>
                    <Col md={8}>
                        <SocialItems/>
                    </Col>
                    <Col md={12}>
                        <p className='info-address'>Rua da União, 439, Boa Vista, Recife,
                        Pernambuco, Brasil, CEP: 50050-909
                        CNPJ: 11.426.103/0001-34
                        Inscrição Estadual: Isenta</p>
                    </Col>
                </Row>
            </Col>
        </Row>
    </Container>
}